import * as yup from 'yup';
import {
  hasWohneigentumValidator,
  versicherungsnehmerSchema as versicherungsnehmerSchemaBase,
} from '@/features/Sparten/shared/schema/kfz/versicherungsnehmerSchema/versicherungsnehmerSchema';
import { JAHRESKARTE_OEPNV_TYP } from '@/features/Sparten/pkwv2/jahreskarteOepnv';

const wohneigentumSchema = yup.object({
  gesellschaftID: yup
    .number()
    .default(0)
    .test(
      'hasWohneigentum',
      'Bitte füllen Sie das Pflichtfeld aus.',
      hasWohneigentumValidator,
    ),
  isVermietet: yup.boolean().default(false),
  typ: yup.string().default(''),
});

export const versicherungsnehmerSchema = versicherungsnehmerSchemaBase.concat(
  yup.object({
    hasJahreskarteOeffentlicherPersonenverkehr: yup.boolean().default(false),
    jahreskarteOeffentlicherPersonenverkehr: yup
      .string()
      .oneOf(Object.values(JAHRESKARTE_OEPNV_TYP))
      .default(JAHRESKARTE_OEPNV_TYP.BAHN_NORMAL),
    hasAnBegleitetenFahrenTeilgenommen: yup.boolean().default(false),
    hasWohneigentum: yup.boolean().default(false),
    wohneigentum: wohneigentumSchema,
    anSicherheitstrainingTeilnahmedatum: yup.date().nullable().default(null),
    hasPunkteInFlensburg: yup.boolean().default(false),
  }),
);
